export const DEFAULT_CURRENCY = {label: 'USD / Доллар США', value: 'USD'};
export const DEFAULT_CITY = {key: 'almaty', ru: 'Алматы'};

export const SELECTED_CITY = 'selected-location';
export const OLD_SELECTED_CITY = 'selectedLocation';

export const RU_LANGUAGE = 'ru';
export const KZ_LANGUAGE = 'kk-KZ';
export const DEFAULT_LANGUAGE = 'ru-KZ';
export const GOOGLE_SEARCH = 'https://www.google.com/maps/search/?api=1';

export const AUCTION_OPEN = 'open';
export const AUCTION_CLOSED = 'closed';
export const AUCTION_SUCCESS = 'success';
export const AUCTION_SUSPENSE = 'suspense';
export const AUCTION_LOADING = 'loading';

export const DESKTOP_HEADER_HEIGHT = 88;

export const DEFAULT_OPEN_HOURS = 9;
export const DEFAULT_CLOSE_HOURS = 18;

export const AUCTION_RATE_LIMIT_ERROR = 'AUCTION_CREATE_RATE_LIMIT';

export const ALL_REGIONS = 'Все районы';

export const DEFAULT_CURRENCIES_LIST = ['USD', 'EUR', 'RUB'];
export const AUCTION_OPERATIONS = [
  {
    code: 'buy',
    text: 'Купить валюту'
  },
  {
    code: 'sell',
    text: 'Продать валюту'
  }
];
